import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  EmployeePay,
  MasterPayrollObject,
  OpenPaylineDetailsArgs,
  Payline,
  PayrollStartData
} from '../../../../models/payroll';
import { HistoryVoidSelection } from '../history-void-selection/history-void-selection.component';

@Component({
  selector: 'lib-history-void-details',
  templateUrl: './history-void-details.component.html',
  standalone: false
})
export class HistoryVoidDetailsComponent implements OnInit {
  @Output() handleBack = new EventEmitter();
  @Output() handleContinue: EventEmitter<HistoryVoidSelection> = new EventEmitter();

  @Input() args: OpenPaylineDetailsArgs;
  @Input() deductionConfigs: {};
  @Input() earningConfigs: {};
  @Input() employeePay: EmployeePay;
  @Input() payroll: MasterPayrollObject;
  @Input() selPayroll: HistoryVoidSelection;
  @Input() startData: PayrollStartData;
  @Input() taxConfigs: {};

  ngOnInit(): void {}

  public onBack() {
    this.handleBack.emit();
  }

  public onContinue() {
    this.handleContinue.emit(this.selPayroll);
  }
}
